var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Input } from '..';
import { switchSize } from './switchSizes';
const getSwitchStyles = (size) => {
    const { width, height } = switchSize[size];
    return {
        bg: 'transparent',
        border: `1px solid`,
        borderColor: 'neutralBorderStrongDisabled',
        borderRadius: '15.5px',
        cursor: 'pointer',
        appearance: 'none',
        position: 'relative',
        width,
        height,
        transition: '0.3s ease',
        padding: '0',
        outline: '1px solid',
        outlineColor: 'transparent',
        outlineOffset: '1px',
        '&::before': {
            content: '""',
            border: `1px solid`,
            borderColor: 'neutralBorderStrongDisabled',
            position: 'absolute',
            bg: 'neutralBg',
            left: '-1px',
            top: '-1px',
            width: '60%',
            height: '100%',
            borderRadius: '50%',
            transition: '0.3s ease',
            boxSizing: 'content-box',
        },
        ':focus': {
            borderColor: 'neutralBorderStrongDisabled',
            boxShadow: ({ colors }) => `0 0 0 4px ${colors.baseBorderWeakActive}`,
            outline: 'transparent solid 4px',
        },
        ':focus:not(:focus-visible)': {
            boxShadow: 'none',
        },
        '&:checked': {
            bg: 'baseBg',
            borderColor: 'baseBorder',
            '::before': {
                transform: `translateX(60%)`,
                borderColor: 'baseBorder',
            },
        },
        ':disabled': {
            cursor: 'default',
            borderColor: 'neutralBorderWeakDisabled',
            '&::before': {
                borderColor: 'neutralBorderWeakDisabled',
            },
            '&:checked': {
                bg: 'neutralBorderWeakDisabled',
                borderColor: 'neutralBorderWeakDisabled',
                '::before': {
                    bg: 'neutralBgMedium',
                    borderColor: 'neutralBorderWeakDisabled',
                },
            },
        },
    };
};
const ToggleSwitch = (_a) => {
    var { size = 's', sx } = _a, props = __rest(_a, ["size", "sx"]);
    return (_jsx(Box, Object.assign({ sx: sx }, { children: _jsx(Input, Object.assign({}, props, { sx: getSwitchStyles(size), type: "checkbox" })) })));
};
export default ToggleSwitch;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9nZ2xlU3dpdGNoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvY29tbW9ucy9Ub2dnbGVTd2l0Y2gvVG9nZ2xlU3dpdGNoLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFHQSxPQUFPLEVBQUUsR0FBRyxFQUFFLEtBQUssRUFBYyxNQUFNLElBQUksQ0FBQztBQUc1QyxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBRTNDLE1BQU0sZUFBZSxHQUFHLENBQUMsSUFBdUIsRUFBc0IsRUFBRTtJQUN0RSxNQUFNLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxHQUFHLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUUzQyxPQUFPO1FBQ0wsRUFBRSxFQUFFLGFBQWE7UUFDakIsTUFBTSxFQUFFLFdBQVc7UUFDbkIsV0FBVyxFQUFFLDZCQUE2QjtRQUMxQyxZQUFZLEVBQUUsUUFBUTtRQUN0QixNQUFNLEVBQUUsU0FBUztRQUNqQixVQUFVLEVBQUUsTUFBTTtRQUNsQixRQUFRLEVBQUUsVUFBVTtRQUNwQixLQUFLO1FBQ0wsTUFBTTtRQUNOLFVBQVUsRUFBRSxXQUFXO1FBQ3ZCLE9BQU8sRUFBRSxHQUFHO1FBRVosT0FBTyxFQUFFLFdBQVc7UUFDcEIsWUFBWSxFQUFFLGFBQWE7UUFDM0IsYUFBYSxFQUFFLEtBQUs7UUFFcEIsV0FBVyxFQUFFO1lBQ1gsT0FBTyxFQUFFLElBQUk7WUFDYixNQUFNLEVBQUUsV0FBVztZQUNuQixXQUFXLEVBQUUsNkJBQTZCO1lBQzFDLFFBQVEsRUFBRSxVQUFVO1lBQ3BCLEVBQUUsRUFBRSxXQUFXO1lBQ2YsSUFBSSxFQUFFLE1BQU07WUFDWixHQUFHLEVBQUUsTUFBTTtZQUNYLEtBQUssRUFBRSxLQUFLO1lBQ1osTUFBTSxFQUFFLE1BQU07WUFDZCxZQUFZLEVBQUUsS0FBSztZQUNuQixVQUFVLEVBQUUsV0FBVztZQUN2QixTQUFTLEVBQUUsYUFBYTtTQUN6QjtRQUVELFFBQVEsRUFBRTtZQUNSLFdBQVcsRUFBRSw2QkFBNkI7WUFDMUMsU0FBUyxFQUFFLENBQUMsRUFBRSxNQUFNLEVBQUUsRUFBRSxFQUFFLENBQUMsYUFBYSxNQUFPLENBQUMsb0JBQW9CLEVBQUU7WUFDdEUsT0FBTyxFQUFFLHVCQUF1QjtTQUNqQztRQUNELDRCQUE0QixFQUFFO1lBQzVCLFNBQVMsRUFBRSxNQUFNO1NBQ2xCO1FBRUQsV0FBVyxFQUFFO1lBQ1gsRUFBRSxFQUFFLFFBQVE7WUFDWixXQUFXLEVBQUUsWUFBWTtZQUV6QixVQUFVLEVBQUU7Z0JBQ1YsU0FBUyxFQUFFLGlCQUFpQjtnQkFDNUIsV0FBVyxFQUFFLFlBQVk7YUFDMUI7U0FDRjtRQUVELFdBQVcsRUFBRTtZQUNYLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLFdBQVcsRUFBRSwyQkFBMkI7WUFFeEMsV0FBVyxFQUFFO2dCQUNYLFdBQVcsRUFBRSwyQkFBMkI7YUFDekM7WUFFRCxXQUFXLEVBQUU7Z0JBQ1gsRUFBRSxFQUFFLDJCQUEyQjtnQkFDL0IsV0FBVyxFQUFFLDJCQUEyQjtnQkFFeEMsVUFBVSxFQUFFO29CQUNWLEVBQUUsRUFBRSxpQkFBaUI7b0JBQ3JCLFdBQVcsRUFBRSwyQkFBMkI7aUJBQ3pDO2FBQ0Y7U0FDRjtLQUNGLENBQUM7QUFDSixDQUFDLENBQUM7QUFNRixNQUFNLFlBQVksR0FBMEIsQ0FBQyxFQUE0QixFQUFFLEVBQUU7UUFBaEMsRUFBRSxJQUFJLEdBQUcsR0FBRyxFQUFFLEVBQUUsT0FBWSxFQUFQLEtBQUssY0FBMUIsY0FBNEIsQ0FBRjtJQUFPLE9BQUEsQ0FDNUUsS0FBQyxHQUFHLGtCQUFDLEVBQUUsRUFBRSxFQUFFLGdCQUNULEtBQUMsS0FBSyxvQkFDQSxLQUFLLElBQ1QsRUFBRSxFQUFFLGVBQWUsQ0FBQyxJQUF5QixDQUFDLEVBQzlDLElBQUksRUFBQyxVQUFVLElBQ2YsSUFDRSxDQUNQLENBQUE7Q0FBQSxDQUFDO0FBRUYsZUFBZSxZQUFZLENBQUMifQ==